import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);

export const getStaticDataLockPeriodsState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataLockPeriodsReducer.lockPeriodsFeatureKey]
);

export const getStaticDataLockPeriodsFailure = createSelector(
  getStaticDataLockPeriodsState,
  staticDataCountriesReducer.fromStaticDataLockPeriodsReducer.getLockPeriodsFailure
);

export const getStaticDataLockPeriodsResponse = createSelector(
  getStaticDataLockPeriodsState,
  staticDataCountriesReducer.fromStaticDataLockPeriodsReducer.getLockPeriodsResponse
);

export const getStaticDataLockPeriodsIsLoaded = createSelector(
  getStaticDataLockPeriodsState,
  staticDataCountriesReducer.fromStaticDataLockPeriodsReducer.getLockPeriodsIsLoaded
);
